export default __webpack_public_path__ + "static/media/gitex-impact.be3da417.jpg";